import { render, staticRenderFns } from "./StepItem.vue?vue&type=template&id=724721a3&scoped=true&"
import script from "./StepItem.vue?vue&type=script&lang=js&"
export * from "./StepItem.vue?vue&type=script&lang=js&"
import style0 from "./StepItem.vue?vue&type=style&index=0&id=724721a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724721a3",
  null
  
)

export default component.exports